// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__M7+--","checkMark":"checkbox_checkMark__6xbwS"};